import React, { useState, useEffect  } from "react";
import Select from "react-select";
import { Row, Col, Form, FormGroup, Label, Input, Button, Card, CardBody } from "reactstrap";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import _ from "lodash";
import Switch from "react-switch";
import PositionsSelect from "../job/positions/Select";
import HeadsSelect from "../job/heads/Select";
import EmployeeReplacementsSelect from "../job/employee_replacements/Select";
import DivisionsSelect from "../job/divisions/Select";
import ManagementsSelect from "../job/managements/Select";
import JobNestedSelects from "../job/nested/Selects";
import TerritoryNestedSelects from "../territory/nested/Selects";
import LaboralAreasSelect from "../laboral/areas/Select";
import EducationLevelsSelect from "../education/levels/Select";
import RequestReasonsSelect from "../job/request_reason/Select"
import ReplacementReasonsSelect from "../job/replacement_reason/Select"
import FixedTermReasonsSelect from "../job/fixed_term_reason/Select"
import RequestingCompaniesSelect from "../job/requesting_company/Select"
import SearchTypesSelect from "../job/search_type/Select"
import FieldWrapper from "../commons/FieldWrapper";
import DraftInput from "../commons/DraftInput";
import PositionFamiliesSelect from "../job/position_family/Select";
import DefaultBenefitsSelector from "../default_benefits/Selector";
import axios from "axios";

const contractTypeOptions = [
  { value: "fixed_term", label: "Plazo Fijo" },
  { value: "indefinite_term", label: "Plazo Indefinido" },
  { value: "practical_term", label: "Práctica" }
];

const PublicationForm = props => {
  const {
    course,
    handleChangeCourse,
    handleChangeJobDescription,
    handleChangeBenefits,
    handleChangeMinisitePublication,
    handleAddQuestion,
    handleRemoveQuestion,
    handleChangeQuestion,
    handleChangeQuestionField,
    handleSubmit,
    isEdit
  } = props;
  console.log("course")
  console.log(course.minisitePublication.mapping)

  const { publicationQuestions } = course.minisitePublication;

  const isConfidential =
    course.minisitePublication.isConfidential.value === true ||
    course.minisitePublication.isConfidential.value === "true"
      ? true
      : false;

  useEffect(() => { }, [publicationQuestions]);

  const [requestReason, setRequestReason] = useState(course.minisitePublication.requestReason.value || "");
  const [mappings, setMappings] = useState([]);
  const [selectedMapping, setSelectedMapping] = useState(null);
  const [recruiters, setRecruiters] = useState([]);
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);

  const [benefitsKey, setBenefitsKey] = useState(0);
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const newQuestions = Array.from(publicationQuestions);
    const [removed] = newQuestions.splice(result.source.index, 1);
    newQuestions.splice(result.destination.index, 0, removed);
    props.handleChangeQuestionField("reorder", newQuestions);
  };

  useEffect(() => {
    axios.get("/api/applicants/recruiters").then((response) => {
      const recruiterOptions = response.data.map((r) => ({
        value: r.value,
        label: r.full_name ? `${r.full_name} (${r.label})` : r.label,
        email: r.label,
        full_name: r.full_name
      }));
      setRecruiters(recruiterOptions);

      const initialRecruiter =
        recruiterOptions.find(r => r.value === course.createdById) ||
        recruiterOptions.find(r => r.email === course.minisitePublication.recruiter.value);

      if (initialRecruiter) {
        setSelectedRecruiter(initialRecruiter);
      }
    });
  }, []);


  useEffect(() => {
    const { mapping } = course.minisitePublication;

    if (isEdit) {
      if (mapping?.value) {
        setSelectedMapping(mapping.label ? mapping : { value: mapping.value, label: `Workflow #${mapping.value}` });
      }
      return;
    }

    axios.get("/api/enrollment_builder/mappings")
      .then(({ data }) => {
        if (!Array.isArray(data)) return;

        const formattedMappings = data.map(({ id, recruiter_workflow }) => ({
          value: id,
          label: recruiter_workflow?.name || `Workflow #${id}`
        }));

        setMappings(formattedMappings);

        const validMapping = formattedMappings.find(m => m.value === mapping?.value) || formattedMappings[0];

        if (validMapping) {
          setSelectedMapping(validMapping);
          handleChangeMinisitePublication(validMapping, "mapping");
        }
      })
      .catch(console.error);
  }, [course.minisitePublication.mapping]);


  const handleMappingChange = (selectedOption) => {
    setSelectedMapping(selectedOption);
    handleChangeMinisitePublication(selectedOption, "mapping");
  };
  const handleRequestReasonChange = (selectedOption) => {
    const newRequestReason = selectedOption.value;
    setRequestReason(newRequestReason);

    handleChangeMinisitePublication(selectedOption, "requestReason");

    if (newRequestReason !== "replacement") {
      handleChangeMinisitePublication({ value: "" }, "replacementReason");
    }
    if (newRequestReason !== "fix_term") {
      handleChangeMinisitePublication({ value: "" }, "fixedTermReason");
    }
    if (newRequestReason !== "replacement" && newRequestReason !== "fix_term") {
      handleChangeMinisitePublication({ value: "" }, "employeeReplacement");
    }
  };

  const validateForm = () => {
    if (requestReason === "replacement" && !course.minisitePublication.replacementReason.value) {
      return false;
    }
    if (requestReason === "fix_term" && !course.minisitePublication.fixedTermReason.value) {
      return false;
    }
    return true;
  };

  // Función para validar solo patrones realmente peligrosos
  const validateSecurityPatterns = (value) => {
    if (typeof value !== 'string') return { isValid: true, message: '' };
    
    // Solo detectar patrones realmente peligrosos
    const dangerousPatterns = [
      { pattern: /<script[^>]*>/gi, message: 'No se permiten etiquetas script' },
      { pattern: /javascript:/gi, message: 'No se permiten enlaces javascript' },
      { pattern: /on\w+\s*=/gi, message: 'No se permiten event handlers' },
      { pattern: /<iframe[^>]*>/gi, message: 'No se permiten iframes' },
      { pattern: /<object[^>]*>/gi, message: 'No se permiten objetos embebidos' },
      { pattern: /<embed[^>]*>/gi, message: 'No se permiten embebidos' },
      { pattern: /expression\s*\(/gi, message: 'No se permiten expresiones CSS' },
      { pattern: /eval\s*\(/gi, message: 'No se permite código eval' },
      { pattern: /import\s*\(/gi, message: 'No se permiten imports dinámicos' }
    ];
    
    for (const { pattern, message } of dangerousPatterns) {
      if (pattern.test(value)) {
        return { isValid: false, message };
      }
    }
    
    return { isValid: true, message: '' };
  };

  const handleFormSubmit = (e) => {
    if (!e || typeof e.preventDefault !== "function") {
      return;
    }
    e.preventDefault();
    
    // Validar solo patrones realmente peligrosos
    const textFields = [
      'title', 'jobDescription', 'address', 'requirements', 
      'benefits', 'knowledges', 'location', 'positionFamily'
    ];
    
    let hasErrors = false;
    let errorMessage = '';
    
    textFields.forEach(field => {
      const value = course[field]?.value || course.minisitePublication[field]?.value;
      if (value && typeof value === 'string') {
        const validation = validateSecurityPatterns(value);
        if (!validation.isValid) {
          hasErrors = true;
          errorMessage = validation.message;
        }
      }
    });
    
    if (hasErrors) {
      alert(`Error de seguridad: ${errorMessage}`);
      return;
    }
    
    handleSubmit();
  };

  const handleAddOption = (qIdx) => {
    const val = publicationQuestions[qIdx].newOption?.trim();
    if (val && !publicationQuestions[qIdx].options.includes(val)) {
      handleChangeQuestionField("options", [...(publicationQuestions[qIdx].options || []), val], qIdx);
      handleChangeQuestionField("newOption", "", qIdx);
    }
  };

  const handleRemoveOption = (qIdx, optIdx) => {
    const opts = [...(publicationQuestions[qIdx].options || [])];
    opts.splice(optIdx, 1);
    handleChangeQuestionField("options", opts, qIdx);
  };

  const handleEditOption = (qIdx, optIdx, value) => {
    const opts = [...(publicationQuestions[qIdx].options || [])];
    opts[optIdx] = value;
    handleChangeQuestionField("options", opts, qIdx);
  };

  return (
    <Form onSubmit={handleFormSubmit}>
      <Card className="mb-3 material-shadow">
        <h3 className="card-header h6 fw-bold input_match">
          <i className="fas fa-business-time me-2" aria-hidden="true"></i>
          Detalles Internos Solicitud (No se mostrarán en la publicación)
        </h3>
        <CardBody>
          <Row>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="mapping">Workflow Asociado</Label>
                {isEdit ? (
                  <Input
                    type="text"
                    value={selectedMapping ? selectedMapping.label : "No asignado"}
                    readOnly
                  />
                ) : (
                  <Select
                    options={mappings}
                    onChange={handleMappingChange}
                    value={selectedMapping}
                    placeholder="Seleccione un workflow"
                  />
                )}
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="requestingCompany" className="input_required">Empresa que Solicita</Label>
                <FieldWrapper errors={course.minisitePublication.requestingCompany.errors}>
                  <RequestingCompaniesSelect
                    value={course.minisitePublication.requestingCompany}
                    handleChange={handleChangeMinisitePublication}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="searchType" className="input_required">Búsqueda</Label>
                <FieldWrapper errors={course.minisitePublication.searchType.errors}>
                <SearchTypesSelect
                  value={course.minisitePublication.searchType}
                  handleChange={handleChangeMinisitePublication}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="position" className="input_required">Cargo</Label>
                <FieldWrapper errors={course.minisitePublication.position.errors}>
                  <PositionsSelect
                    handleChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.position}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label htmlFor="head" className="input_required">Jefatura Directa</Label>
                <FieldWrapper errors={course.minisitePublication.head.errors}>
                  <HeadsSelect
                    handleChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.head}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <JobNestedSelects
              handleChange={handleChangeMinisitePublication}
              divisionValue={course.minisitePublication.division}
              managementValue={course.minisitePublication.management}
            />
          </Row>
          <fieldset className="form-group">
            <hr/>
            <Row>
              <Col lg="4" md="3">
                <FormGroup>
                  <Label htmlFor="requestReason" className="input_required">Motivo de Solicitud</Label>
                  <FieldWrapper errors={course.minisitePublication.requestReason.errors}>
                  <RequestReasonsSelect
                    value={course.minisitePublication.requestReason}
                    handleChange={handleRequestReasonChange}
                  />
                  </FieldWrapper>
                </FormGroup>
              </Col>

              {requestReason === "replacement" && (
                <Col lg="4" md="3">
                  <FormGroup>
                    <Label htmlFor="replacementReason" className="input_required">Motivo del Reemplazo</Label>
                    <FieldWrapper errors={course.minisitePublication.replacementReason.errors}>
                      <ReplacementReasonsSelect
                        value={course.minisitePublication.replacementReason}
                        handleChange={handleChangeMinisitePublication}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
              )}

              {requestReason === "fix_term" && (
                <Col lg="4" md="3">
                  <FormGroup>
                    <Label htmlFor="fixedTermReason" className="input_required">Motivo del Plazo Fijo</Label>
                    <FieldWrapper errors={course.minisitePublication.fixedTermReason.errors}>
                      <FixedTermReasonsSelect
                        value={course.minisitePublication.fixedTermReason}
                        handleChange={handleChangeMinisitePublication}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
              )}
              {(requestReason === "fix_term" || requestReason === "replacement") && (
                <Col md="4">
                  <FormGroup>
                    <Label htmlFor="employee_replacement" className="input_required">A quién reemplaza</Label>
                    <FieldWrapper errors={course.minisitePublication.employeeReplacement.errors}>
                      <EmployeeReplacementsSelect
                        handleChange={handleChangeMinisitePublication}
                        value={course.minisitePublication.employeeReplacement}
                      />
                    </FieldWrapper>
                  </FormGroup>
                </Col>
              )}
            </Row>
          </fieldset>
          <hr />
          <Row>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="bukId" className="input_required">ID de BUK</Label>
                <FieldWrapper errors={course.minisitePublication.bukId.errors}>
                  <Input
                    id="bukId"
                    name="bukId"
                    placeholder="ID de BUK"
                    type="number"
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.bukId.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="recruiter" className="input_required">
                  Reclutador
                </Label>
                <FieldWrapper errors={course.minisitePublication.recruiter.errors}>
                  <Select
                    id="recruiter"
                    name="recruiter"
                    placeholder="Seleccione un reclutador"
                    value={selectedRecruiter}
                    onChange={(e) => {
                      setSelectedRecruiter(e);
                      handleChangeMinisitePublication(e, "recruiter");
                    }}
                    options={recruiters}
                  />



                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="location" className="input_required">
                  Ubicación
                </Label>
                <FieldWrapper errors={course.minisitePublication.location.errors}>
                  <Input
                    id="location"
                    name="location"
                    placeholder="Ubicación"
                    type="text"
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.location.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="profilePosition" >
                  Perfil del cargo (archivo PDF, DOCX, etc)
                </Label>
                <FieldWrapper errors={course.minisitePublication.profilePositionFile?.errors}>
                  <Input
                    id="profilePositionFile"
                    name="profilePositionFile"
                    type="file"
                    accept=".pdf,.doc,.docx,.odt,.txt"
                    onChange={e => {
                      const file = e.target.files[0];
                      props.handleChangeMinisitePublication(file, "profilePositionFile");
                    }}
                  />

                  {course.minisitePublication.profilePositionFileUrl && (
                    <div className="mt-2">
                      Archivo guardado:{" "}
                      <a href={course.minisitePublication.profilePositionFileUrl} target="_blank" rel="noopener noreferrer">
                        {course.minisitePublication.profilePositionFileName || "Descargar"}
                      </a>
                      <Button
                        size="sm"
                        color="danger"
                        className="ms-2"
                        onClick={() => props.handleChangeMinisitePublication(null, "profilePositionFile")}
                      >
                        Eliminar
                      </Button>
                    </div>
                  )}

                  {course.minisitePublication.profilePositionFile?.value && (
                    <div className="mt-2">
                      Archivo a subir: {course.minisitePublication.profilePositionFile.value.name}
                      <Button size="sm" color="danger" onClick={() => props.handleChangeMinisitePublication(null, "profilePositionFile")}>
                        Quitar
                      </Button>
                    </div>
                  )}

                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="requestReason" className="input_required">Familia del cargo</Label>
                <FieldWrapper errors={course.minisitePublication.positionFamily.errors}>
                <PositionFamiliesSelect
                  value={course.minisitePublication.positionFamily}
                  handleChange={handleChangeMinisitePublication}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="3">
              <FormGroup>
                <Label htmlFor="vacancyRequester" className="input_required">
                  Quien solicita la vacante
                </Label>
                <FieldWrapper errors={course.minisitePublication.vacancyRequester.errors}>
                  <Input
                    id="vacancyRequester"
                    name="vacancyRequester"
                    placeholder="Quien solicita la vacante"
                    type="text"
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.vacancyRequester.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-4 material-shadow">
        <CardBody>
          <Row>
            <Col lg="12" md="12">
              <FormGroup>
                <Label htmlFor="title" className="input_required">
                  Título de publicación
                </Label>
                <FieldWrapper errors={course.title.errors}>
                  <Input
                    id="title"
                    name="title"
                    placeholder="Título de publicación"
                    type="text"
                    maxLength={60}
                    onChange={handleChangeCourse}
                    value={course.title.value}
                  />
                </FieldWrapper>
              </FormGroup>
              <FormGroup>
                <Label for="jobDescription" className="input_required">
                  Descripción del Cargo
                </Label>
                <FieldWrapper errors={course.jobDescription.errors}>
                  <DraftInput id="jobDescription" onChangeInput={handleChangeJobDescription} value={course.jobDescription.value} />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="vacancies" className="input_required">
                  Vacantes
                </Label>
                <FieldWrapper errors={course.vacancies.errors}>
                  <Input
                    id="vacancies"
                    name="vacancies"
                    placeholder="Vacantes"
                    type="number"
                    min="1"
                    onChange={handleChangeCourse}
                    value={course.vacancies.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="desactivateAt" className="input_required">
                  Fecha Expiración (30 días máx.)
                </Label>
                <FieldWrapper errors={course.minisitePublication.desactivateAt.errors}>
                  <Input
                    id="desactivateAt"
                    name="desactivateAt"
                    placeholder="Fecha Expiración"
                    type="date"
                    min={new Date().toISOString().slice(0,10)}
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.desactivateAt.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
           <Col lg="4" md="4">
              <FormGroup check>
                <Label check className="d-flex align-items-top justify-content-between">
                  <Switch
                    checked={isConfidential}
                    onChange={e => handleChangeMinisitePublication(e, "isConfidential")}
                    offColor="#ff3547"
                    onColor="#00c851"
                    onHandleColor="#00c851"
                    offHandleColor="#ff3547"
                    handleDiameter={30}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={15}
                    width={43}
                    className="react-switch align-middle"
                    id="material-switch"
                  />
                  <div className="d-inline-block">
                    ¿Publicación Confidencial?
                    <small className="form-text text-muted">
                      {/* descripción por definir */}
                    </small>
                  </div>
                </Label>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md="3">
              <FormGroup>
                <Label htmlFor="address" className="input_required">
                  Dirección
                </Label>
                <FieldWrapper errors={course.minisitePublication.address.errors}>
                  <Input
                    id="address"
                    name="address"
                    placeholder="Dirección"
                    type="text"
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.address.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <TerritoryNestedSelects
              handleChange={handleChangeMinisitePublication}
              countryValue={course.minisitePublication.country}
              regionValue={course.minisitePublication.region}
              communeValue={course.minisitePublication.commune}
            />
          </Row>
        </CardBody>
      </Card>


      <Card className="mb-3 material-shadow">
        <h3 className="card-header h6 fw-bold">
          <i className="fas fa-business-time me-2" aria-hidden="true"></i>
          Detalles Laborales
        </h3>
        <CardBody>
          <fieldset className="form-group">
            <Row>
              <legend className="col-form-label pt-0 col-sm-4">Jornada Laboral</legend>
              <Col sm="8">
                <Row>
                  <Col md="3">
                    <FormGroup check>
                      <Label htmlFor="preferredScheduleCheck1">
                        <Input
                          id="preferredScheduleCheck1"
                          name="preferredSchedule"
                          type="radio"
                          value="part_time"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredSchedule.value === "part_time"}
                        />
                        Part Time
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup check>
                      <Label htmlFor="preferredScheduleCheck2">
                        <Input
                          id="preferredScheduleCheck2"
                          name="preferredSchedule"
                          type="radio"
                          value="full_time"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredSchedule.value === "full_time"}
                        />
                        Jornada Completa
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup check>
                      <Label htmlFor="preferredScheduleCheck3">
                        <Input
                          id="preferredScheduleCheck3"
                          name="preferredSchedule"
                          type="radio"
                          value="half_time"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredSchedule.value === "half_time"}
                        />
                        Media Jornada
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="3">
                    <FormGroup check>
                      <Label htmlFor="preferredScheduleCheck4">
                        <Input
                          id="preferredScheduleCheck4"
                          name="preferredSchedule"
                          type="radio"
                          value="remote_work"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredSchedule.value === "remote_work"}
                        />
                        Teletrabajo
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <FieldWrapper errors={course.minisitePublication.preferredSchedule.errors}></FieldWrapper>
            </Row>
          </fieldset>
          <hr />
          <fieldset className="form-group">
            <Row>
              <legend className="col-form-label pt-0 col-sm-4">Extensión de la jornada</legend>
              <Col sm="8">
                <Row>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredLaborDay1">
                        <Input
                          id="preferredLaborDay1"
                          name="preferredLaborDay"
                          type="radio"
                          value="monday_friday"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredLaborDay.value === "monday_friday"}
                        />
                        Lunes a Viernes
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredLaborDay2">
                        <Input
                          id="preferredLaborDay2"
                          name="preferredLaborDay"
                          type="radio"
                          value="monday_sunday"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredLaborDay.value === "monday_sunday"}
                        />
                        Lunes a Domingo
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredLaborDay3">
                        <Input
                          id="preferredLaborDay3"
                          name="preferredLaborDay"
                          type="radio"
                          value="weekends"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredLaborDay.value === "weekends"}
                        />
                        Fines de Semana
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <FieldWrapper errors={course.minisitePublication.preferredLaborDay.errors}></FieldWrapper>
            </Row>
          </fieldset>
          <hr />
          <fieldset className="form-group">
            <Row>
              <legend className="col-form-label pt-0 col-sm-4">Horarios y/o Turnos</legend>

              <Col sm="8">
                <Row>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredTurn1">
                        <Input
                          id="preferredTurn1"
                          name="preferredTurn"
                          type="radio"
                          value="day_time"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredTurn.value === "day_time"}
                        />
                        Diurno
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredTurn2">
                        <Input
                          id="preferredTurn2"
                          name="preferredTurn"
                          type="radio"
                          value="vespertine"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredTurn.value === "vespertine"}
                        />
                        Vespertino
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="preferredTurn3">
                        <Input
                          id="preferredTurn3"
                          name="preferredTurn"
                          type="radio"
                          value="rotative"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.preferredTurn.value === "rotative"}
                        />
                        Rotativos
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <FieldWrapper errors={course.minisitePublication.preferredTurn.errors}></FieldWrapper>
            </Row>
          </fieldset>
          <hr/>
          <FormGroup tag="fieldset">
            <Row>
              <Col sm="4">
                <legend className="col-form-label pt-0 pb-0 mb-0" id="dressCodeLabel">
                  Código de Vestimenta Laboral Formal
                </legend>
                <p className="form-text text-muted lh-sm small mb-0">
                  A algunas personas les importa saber si tu empresa cuenta con una política de vestimenta formal.
                </p>
              </Col>
              <Col sm="8">
                <Row>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="dressCode1">
                        <Input
                          id="dressCode1"
                          name="dressCode"
                          type="radio"
                          value="yes"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.dressCode.value === "yes"}
                        />
                        Si
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="dressCode2">
                        <Input
                          id="dressCode2"
                          name="dressCode"
                          type="radio"
                          value="no"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.dressCode.value === "no"}
                        />
                        No
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check>
                      <Label htmlFor="dressCode3">
                        <Input
                          id="dressCode3"
                          name="dressCode"
                          type="radio"
                          value="indifferent"
                          onChange={handleChangeMinisitePublication}
                          checked={course.minisitePublication.dressCode.value === "indifferent"}
                        />
                        Indiferente
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </Col>
              <FieldWrapper errors={course.minisitePublication.dressCode.errors}></FieldWrapper>
            </Row>
          </FormGroup>
        </CardBody>
      </Card>
      <Card className="mb-4 material-shadow">
        <h3 className="card-header h6 fw-bold">
          <i className="far fa-smile-wink me-2" aria-hidden="true"></i>
          Beneficios
        </h3>
        <CardBody>
          <FormGroup>
            <Label htmlFor="benefits" className="input_required">Detalle de Beneficios</Label>
            <DefaultBenefitsSelector
              onPick={({ content }) => {
                handleChangeBenefits(content);
                setBenefitsKey(k => k + 1);
              }}
            />
            <FieldWrapper errors={course.minisitePublication.benefits.errors}>
              <DraftInput
                key={`benefits-${benefitsKey}`}
                value={course.minisitePublication.benefits.value}
                onChangeInput={handleChangeBenefits}
              />
            </FieldWrapper>
          </FormGroup>
          <Row className="d-flex justify-content-center align-items-center">
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="contractType" className="input_required">Tipo de Contrato</Label>
                <FieldWrapper errors={course.contractType.errors}>
                  <Select
                    inputId="contractType"
                    onChange={e => handleChangeCourse(e, "contractType")}
                    options={contractTypeOptions}
                    placeholder="Seleccione una opción"
                    value={course.contractType.value ? course.contractType : null}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-4 material-shadow">
        <h3 className="card-header h6 fw-bold">
          <i className="fas fa-list-ul me-2" aria-hidden="true"></i>
          Requerimientos del Cargo
        </h3>
        <CardBody>
          <Row>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="experienceYears" className="input_required">Años de Experiencia</Label>
                <FieldWrapper errors={course.minisitePublication.experienceYears.errors}>
                  <Input
                    id="experienceYears"
                    name="experienceYears"
                    placeholder="Años de Experiencia"
                    type="number"
                    min="0"
                    onChange={handleChangeMinisitePublication}
                    value={course.minisitePublication.experienceYears.value || ''}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="4" md="4">
              <FormGroup>
                <Label htmlFor="educationalLevel" className="input_required">Nivel Educacional</Label>
                <FieldWrapper errors={course.minisitePublication.educationLevel.errors}>
                <EducationLevelsSelect
                  value={course.minisitePublication.educationLevel}
                  handleChange={handleChangeMinisitePublication}
                />
                </FieldWrapper>
              </FormGroup>
            </Col>
            <Col lg="12" md="12">
              <FormGroup>
                <Label for="requirements" className="input_required">Requisitos Mínimos</Label>
                <FieldWrapper errors={course.minisitePublication.requirements.errors}>
                  <DraftInput
                    onChangeInput={content => handleChangeMinisitePublication({ target: { name: "requirements", value: content } })}
                    value={course.minisitePublication.requirements.value}
                  />
                </FieldWrapper>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card className="mb-4 material-shadow">
        <h3 className="card-header h6 fw-bold">
          <i className="fas fa-question me-2" aria-hidden="true"></i>
          Preguntas
        </h3>
        <CardBody>
          <p className="alert bg-primary fw-bold text-white material-shadow">
            <i className="fas fa-info-circle" /> Como reclutador, puedes realizar todas las que quieras.
          </p>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="questions-list">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {_.map(publicationQuestions, (question, key) => (
                    <Draggable
                      key={`q${key}`}
                      draggableId={`question-${key}`}
                      index={key}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={`material-shadow mb-3 ${snapshot.isDragging ? 'bg-light' : ''}`}
                        >
                          <Card>
                            <CardBody>
                              <div className="d-flex justify-content-between align-items-center">
                                <span
                                  {...provided.dragHandleProps}
                                  className="drag-icon text-secondary me-2"
                                  style={{
                                    cursor: "grab",
                                    fontSize: 22
                                  }}
                                  title="Arrastra para reordenar"
                                >
                                  <i className="fas fa-grip-vertical"></i>
                                </span>
                                <div className="hit-actions float-end text-end">
                                  <Button
                                    outline
                                    color="danger"
                                    aria-label="Borrar"
                                    title="Borrar"
                                    className="btn-circle d-block"
                                    onClick={() => handleRemoveQuestion(key)}
                                  >
                                    <i className="far fa-trash-alt" aria-hidden="true"></i>
                                  </Button>
                                </div>
                              </div>
                              <Row>
                                <Col lg="12">
                                  <FormGroup>
                                    <Label htmlFor={`question${key}`}>Pregunta {key + 1}</Label>
                                    <FieldWrapper errors={question.errors}>
                                      <Input
                                        id={`question${key}`}
                                        name="question"
                                        placeholder="Escriba aquí su pregunta."
                                        type="textarea"
                                        value={question.value}
                                        onChange={e => handleChangeQuestion(e.target.value, key)}
                                      />
                                    </FieldWrapper>
                                  </FormGroup>
                                </Col>
                                <Col lg="6">
                                  <FormGroup>
                                    <Label>Tipo de Respuesta : {question.isDefault ? " (predefinida)" : ""}</Label>
                                    {question.isDefault ? (
                                      <p className="form-control-plaintext mb-0">
                                        {{
                                          text: "Texto",
                                          number: "Número",
                                          boolean: "Sí / No",
                                          single_choice: "Selección única",
                                          multiple_choice: "Selección múltiple"
                                        }[question.answerType || "text"]}
                                      </p>
                                    ) : (
                                      <Input
                                        id={`answerType${key}`}
                                        name="answerType"
                                        type="select"
                                        value={question.answerType || "text"}
                                        onChange={(e) =>
                                          handleChangeQuestionField("answerType", e.target.value, key)
                                        }
                                      >
                                        <option value="text">Texto</option>
                                        <option value="number">Número</option>
                                        <option value="boolean">Sí / No</option>
                                        <option value="single_choice">Selección única</option>
                                        <option value="multiple_choice">Selección múltiple</option>
                                      </Input>
                                    )}
                                  </FormGroup>
                                </Col>
                              </Row>

                              {["single_choice", "multiple_choice"].includes(question.answerType) && (
                                <Row>
                                  <Col lg="12">
                                    <FormGroup>
                                      <Label>Opciones</Label>
                                      <div className="mb-2 d-flex flex-wrap align-items-center">
                                        <Input
                                          type="text"
                                          placeholder="Nueva opción"
                                          value={question.newOption || ""}
                                          style={{ maxWidth: 250 }}
                                          onChange={e =>
                                            handleChangeQuestionField("newOption", e.target.value, key)
                                          }
                                          onKeyDown={e => {
                                            if (e.key === "Enter") {
                                              e.preventDefault();
                                              handleAddOption(key);
                                            }
                                          }}
                                        />
                                        <Button color="primary" size="sm" className="ms-2" onClick={() => handleAddOption(key)}>
                                          Agregar
                                        </Button>
                                      </div>
                                      <ul className="list-unstyled">
                                        {(question.options || []).map((opt, idx) => (
                                          <li key={idx} className="d-flex align-items-center mb-1">
                                            <Input
                                              type="text"
                                              value={opt}
                                              onChange={e => handleEditOption(key, idx, e.target.value)}
                                              style={{ width: "70%", marginRight: 8 }}
                                            />
                                            <Button
                                              color="danger"
                                              size="sm"
                                              onClick={() => handleRemoveOption(key, idx)}
                                              title="Eliminar opción"
                                            >
                                              <i className="fas fa-trash"></i>
                                            </Button>
                                          </li>
                                        ))}
                                      </ul>
                                      {question.optionsErrors && question.optionsErrors.length > 0 && (
                                        <div className="text-danger small mt-1">
                                          {question.optionsErrors.map((err, i) => (
                                            <div key={i}>{err}</div>
                                          ))}
                                        </div>
                                      )}
                                    </FormGroup>
                                  </Col>
                                </Row>
                              )}
                            </CardBody>
                          </Card>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Row>
            <Col md="12" className="text-start">
              <Button outline color="primary" className="my-4" onClick={() => handleAddQuestion("", false)}>
                <i className="fas fa-plus me-2" aria-hidden="true"></i>
                Agregar Pregunta
              </Button>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col md="12" className="text-end">
              <Button color="primary" type="submit">
                Continuar
                <i className="fas fa-arrow-right ms-2" aria-hidden="true"></i>
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  );
};

export default PublicationForm;
